import { render, staticRenderFns } from "./AdminPermissions.vue?vue&type=template&id=426c0ef4&scoped=true"
import script from "./AdminPermissions.vue?vue&type=script&lang=js"
export * from "./AdminPermissions.vue?vue&type=script&lang=js"
import style0 from "./AdminPermissions.vue?vue&type=style&index=0&id=426c0ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426c0ef4",
  null
  
)

export default component.exports